export default function allTrim(val) {
  return String(val)
    .replace(/\s+/g, ' ')
    .replace(/^\s+|\s+$/, '');
}
